import type { SxProps, Theme } from "@mui/material";

export const breadCrumbsStyles: SxProps<Theme> = {
  "& .MuiBreadcrumbs-ol": {
    flexWrap: "nowrap",
    minWidth: 0,
    alignItems: "center",
  },
  "& .MuiBreadcrumbs-li": {
    overflow: "hidden",
  },
  // hide extra things (which exists in breadcrumbs tooltips) to makre more space for the rest of the
  // breadcrumbs so they won't truncate too much and become unreadable.
  "@container breadcrumbs (width < 1000px)": {
    "[data-extra]": {
      display: "none",
    },
  },
};
